module.exports = __webpack_public_path__ + "static/media/checkheader-min.5361a125.png";